//handles different displays for data snapshot fields
export enum SnapshotFieldType {
  Default = 0, //type string: render as it appears
  YesNo = 1, //type boolean: render as 'Yes' or 'No'
  Date = 2, //type Date: render and format UTC in long date format "January 1, 2025"
  Currency = 3, //type string: render as format as currency "$50.00"
  Lookup = 4, //type int: look up from list and render 'displayValue' of the lookup item
  Phone = 5, //type object: collection of phone numbers render and format using PhoneNumberPipe
  PostalCode = 6, //type string: render and format using PostalCodePipe
  SocialInsuranceNumber = 7, //type string: render and format using SocialInsuranceNumberPipe
  Address = 8, //type object: address fields
  IndianRegistrationNumber = 9,
  MovedFromLocation = 10,
  Municipality = 11,
  DocumentList = 12,
  Number = 13, //type number
  CalloutContent = 14, //type callout content to display a callout inline with data
}
